import { investmentEntityTypes } from '../../../../config/config';
import { fontSizes } from '../../../../constants/constants';
import dynamicfunction from '../../../../utils/dynamicfunction';
import { Checkbox, ErrorText, RadioButton, RowView, Text } from '../index';

const FIThen = ({
  getContent,
  values,
  setFieldValue,
  setFieldError,
  setFieldTouched,
  touched,
  optionsYesOrNO,
  errors,
}) => {
  const { TextWeight } = dynamicfunction();
  const investmentEntityTypeData = investmentEntityTypes(getContent)

  return (
    <>
      <div className='pt-3 sm:pt-5'>
        <Text
          text={getContent('if_fi_then')}
          size={fontSizes.h18}
          isTruncate={false}
          weight={TextWeight.medium}
          className='block'
          isRequired={true}
        />
      </div>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('depository_institution')}
            value={values?.depositoryInstitution}
            onChange={(e) => {
              setFieldValue('depositoryInstitution', e);
              setFieldTouched('depositoryInstitution', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText text={getContent(touched?.depositoryInstitution ? errors?.depositoryInstitution : '')} />
        </div>
        <div className='w-full'>
          <RadioButton
            label={getContent('custodial_institution')}
            value={values?.custodialInstitution}
            onChange={(e) => {
              setFieldValue('custodialInstitution', e);
              setFieldTouched('custodialInstitution', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText text={getContent(touched?.custodialInstitution ? errors?.custodialInstitution : '')} />
        </div>
        <div className='w-full'>
          <RadioButton
            label={getContent('specified_insurance_company')}
            value={values?.specifiedInsuranceCompany}
            onChange={(e) => {
              setFieldValue('specifiedInsuranceCompany', e);
              setFieldTouched('specifiedInsuranceCompany', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText text={getContent(touched?.specifiedInsuranceCompany ? errors?.specifiedInsuranceCompany : '')} />
        </div>
      </RowView>
      <div className='w-full pt-3 sm:pt-5'>
        <RadioButton
          label={getContent('are_you_an_investment_entity')}
          value={values?.anInvestmentEntityGrossIncomePrimarily}
          onChange={(e) => {
            setFieldValue('anInvestmentEntityGrossIncomePrimarily', e);
            setFieldTouched('anInvestmentEntityGrossIncomePrimarily', false);
          }}
          options={optionsYesOrNO}
          required={false}
        />
        <ErrorText
          text={getContent(touched?.anInvestmentEntityGrossIncomePrimarily ? errors?.anInvestmentEntityGrossIncomePrimarily : '')}
        />
      </div>
      {values?.anInvestmentEntityGrossIncomePrimarily === '1' &&
        <div>
          <Checkbox
            value={values?.investmentEntityTypes}
            keyValue={'value'}
            required={false}
            onChange={(option) => {
              const alreadySelected =
                values?.investmentEntityTypes?.[0]?.valueId === option?.id;
              if (alreadySelected) {
                setFieldValue('investmentEntityTypes', []);
                setFieldTouched('investmentEntityTypes', true, false);
              } else {
                setFieldValue('investmentEntityTypes', [
                  { valueId: option?.id },
                ]);
                setFieldTouched('investmentEntityTypes', false, true);
              }
            }}
            options={investmentEntityTypeData}
            isVertical
          />
          <ErrorText text={getContent(touched?.investmentEntityTypes ? errors?.investmentEntityTypes : '')} className='block' />
        </div>
      }
      <div className='w-full pt-3 sm:pt-5'>
        <RadioButton
          label={getContent('investment_entity_non_participating_country')}
          value={
            values?.financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
          }
          onChange={(e) => {
            setFieldValue(
              'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
              e
            );
            setFieldTouched(
              'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
              false
            );
          }}
          options={optionsYesOrNO}
          required={false}
        />
        <ErrorText
          text={getContent(
            touched?.financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ? errors?.financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              : ''
          )}
        />
      </div>
    </>
  );
};
export default FIThen;
